import { render } from "./FoldersList.vue?vue&type=template&id=cc33b352&scoped=true"
import script from "./FoldersList.vue?vue&type=script&lang=js"
export * from "./FoldersList.vue?vue&type=script&lang=js"

import "./FoldersList.vue?vue&type=style&index=0&id=cc33b352&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc33b352"]])

export default __exports__